/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { TxService } from '../shared/tx.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  constructor(
    private envService: TxService,
    private httpClient: HttpClient,
    private helperService: HelperService,
    private localStorageData: LocalStorageService
  ) {}

  public get token(): string {
    return this.localStorageData.getItem(localStorageKeys.TOKEN);
  }

  public set token(value: string) {
    this.localStorageData.setItem(localStorageKeys.TOKEN, value);
  }

  public get platformID(): string {
    return this.localStorageData.getItem(localStorageKeys.PLATFORM_ID);
  }

  public set platformID(value: string) {
    this.localStorageData.setItem(localStorageKeys.PLATFORM_ID, value);
  }

  public get deviceID(): string {
    return this.localStorageData.getItem(localStorageKeys.DEVICE_ID);
  }
  public set deviceID(value: string) {
    this.localStorageData.setItem(localStorageKeys.DEVICE_ID, value);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private get mobileRegistrationApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.mobileRegistrationApi = `${this.envService.mobileRegistrationApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private set mobileRegistrationApi(value: string) {}

  private get sendLocationCoordinatesApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendLocationCoordinatesApi = `${this.envService.sendLocationCoordinatesApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private set sendLocationCoordinatesApi(value: string) {}

  initApiParams() {
    this.apiParams = {};
  }

  // http://devapi.travelx.ai/api/userRegistration?key=bcqvmn2gabuu&pid=trxa
  public mobileRegistration(mobileRegistrationRequest): Observable<any> {
    this.initApiParams();
    if (this.token) {
      this.apiParams.token = this.token;
    }
    return this.httpClient.post(
      this.mobileRegistrationApi,
      mobileRegistrationRequest
    );
  }
  public sendLocationCoordiantes(requestData): Observable<any> {
    this.initApiParams();
    if (this.token) {
      this.apiParams.token = this.token;
    }
    return this.httpClient.post(this.sendLocationCoordinatesApi, requestData);
  }
}
